"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _button = require("../../button");
var _icon = _interopRequireDefault(require("../../icon"));
var _BlockWrapper = _interopRequireDefault(require("./BlockWrapper"));
var _Searchable = _interopRequireDefault(require("../Searchable"));
var _Age = _interopRequireDefault(require("./Age"));
var _Toolbox = _interopRequireDefault(require("../Toolbox"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getInteractionType = function getInteractionType(thresholds) {
  if (thresholds.isBetween) return 'between';
  var min = R.prop('min', thresholds);
  var max = R.prop('max', thresholds);
  if (min && max) return 'between';
  if (min) return thresholds.isInclusive ? '>=' : '>';
  if (max) return thresholds.isInclusive ? '<=' : '<';
  if (min === null && max === null) return 'empty';
  return '';
};
var ThresholdMember = /*#__PURE__*/function (_React$Component) {
  _inherits(ThresholdMember, _React$Component);
  var _super = _createSuper(ThresholdMember);
  function ThresholdMember(props) {
    var _this;
    _classCallCheck(this, ThresholdMember);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "clearFocus", function () {
      _this.setState({
        isFocused: false
      });
    });
    _this.state = {
      isFocused: false
    };
    return _this;
  }
  _createClass(ThresholdMember, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var isFocused = this.state.isFocused;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        labels = _this$props.labels,
        blockType = _this$props.blockType,
        thresholds = _this$props.thresholds,
        ruleIndex = _this$props.ruleIndex,
        thresholdIndex = _this$props.thresholdIndex,
        actions = _this$props.actions,
        thresholdRowIndex = _this$props.thresholdRowIndex,
        blockData = _this$props.blockData;
      var andData = R.path(['thresholdRows', 1], thresholds);
      var interactionType = getInteractionType(blockData);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "threshold-block",
        onClick: function onClick() {
          return _this2.setState({
            isFocused: true
          });
        },
        role: "button",
        tabIndex: 0,
        onBlur: this.clearFocus,
        onKeyPress: function onKeyPress() {
          return _this2.setState({
            isFocused: true
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", {
        className: "threshold-element threshold-header"
      }, (0, _utils.toUpper)(blockType === 'if' ? labels.PENSION_PENSIONABLE_SALARY_IF_LABEL : labels.PENSION_PENSIONABLE_SALARY_AND_LABEL)), isFocused && blockType !== 'if' && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button delete-member",
        onMouseDown: function onMouseDown(ev) {
          var morphedData = R.clone(thresholds);
          ev.stopPropagation();
          morphedData.thresholdRows.splice(1);
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-delete",
        size: 14
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "threshold-element"
      }, blockType === 'if' ? /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
        disabled: true,
        id: "".concat(ruleIndex, "-threshold-pensionable-label"),
        keysPath: [],
        description: labels.PENSION_PENSIONABLE_SALARY_DESCRIPTION,
        error: null,
        labels: labels,
        formulaChange: function formulaChange() {},
        displayName: labels.PENSION_PENSIONABLE_SALARY_LABEL,
        value: labels.PENSION_PENSIONABLE_SALARY_LABEL,
        searchableAction: function searchableAction() {}
      }) : /*#__PURE__*/_react["default"].createElement(_Age["default"], {
        disabled: disabled,
        id: "".concat(ruleIndex, "-age-").concat(thresholdIndex),
        className: "threshold-element",
        ageType: blockData.field,
        isFocused: false,
        date: blockData.date || new Date(),
        onChangeAgeType: function onChangeAgeType(update) {
          var morphedData = R.clone(thresholds);
          morphedData.thresholdRows[1].field = update.value;
          if (update.value === 'age-on-date') {
            morphedData.thresholdRows[1].date = (0, _utils.offsetTimezone)();
          }
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
          _this2.clearFocus();
        },
        onChangeDate: function onChangeDate(date) {
          var morphedData = R.clone(thresholds);
          morphedData.thresholdRows[1].date = date;
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "threshold-block-thresholds threshold-element ".concat(interactionType === 'between' ? 'threshold-block-function' : '')
      }, /*#__PURE__*/_react["default"].createElement(_BlockWrapper["default"], _extends({
        blockData: blockData,
        blockType: blockType,
        data: thresholds,
        interactionType: interactionType,
        isFocused: isFocused,
        thresholdRowIndex: thresholdRowIndex,
        andData: andData,
        clearFocus: this.clearFocus
      }, this.props))), isFocused && blockType !== 'and' && !andData && interactionType !== 'between' && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button add-member",
        onMouseDown: function onMouseDown(ev) {
          var morphedData = R.clone(thresholds);
          ev.stopPropagation();
          morphedData.thresholdRows.push({
            field: 'age',
            min: null,
            max: null,
            date: null
          });
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
          _this2.clearFocus();
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-plus",
        size: 14
      })), isFocused && interactionType !== 'between' && /*#__PURE__*/_react["default"].createElement(_Toolbox["default"], _extends({}, this.props, {
        noFunctions: true,
        noBetween: false,
        noGroups: true,
        functionsEnabled: true,
        paranthesesEnabled: true,
        focusedPath: [],
        betweenEnabled: true,
        keysPath: [],
        clearFocus: this.clearFocus
      })));
    }
  }]);
  return ThresholdMember;
}(_react["default"].Component);
ThresholdMember.defaultProps = {
  errors: {},
  disabled: false,
  blockType: '',
  thresholdRowIndex: 0,
  blockData: {}
};
ThresholdMember.propTypes = {
  blockData: _propTypes["default"].shape({}),
  thresholdRowIndex: _propTypes["default"].number,
  blockType: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  /* The threshold index */
  thresholdIndex: _propTypes["default"].number.isRequired,
  /* The rule index */
  ruleIndex: _propTypes["default"].number.isRequired,
  /* The rewards labels */
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  /* The root thresholds for each threshold */
  thresholds: _propTypes["default"].shape({}).isRequired,
  /* The errros object */
  errors: _propTypes["default"].shape({}),
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired
};
ThresholdMember.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "clearFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ThresholdMember",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "blockType": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "thresholdRowIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "blockData": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "thresholdIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "thresholds": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "func"
        }
      },
      "required": true
    }
  }
};
var _default = ThresholdMember;
exports["default"] = _default;